import * as React from "react";
import { Typography } from "antd";
import { IOrganisationIndexCategory } from "../../../organisations/model/OrganisationIndexCategory";
import {
  IIndexHarmonizationReportItem,
  TIndexHarmonizationReportItem,
} from "../../model/IndexHarmonizationReportItem";
import { IOrganisation } from "../../../organisations/model/Organisation";
import DataGrid from "../../../core/ui/components/grid/DataGrid";
const IndexHarmonizationReportPreview = ({
  translate,
  organisations,
  data,
  selectedCategory,
}: {
  translate?: any;
  organisations: IOrganisation[];
  data: IIndexHarmonizationReportItem[];
  title?: string;
  subtitle?: string;
  loader: any;
  selectedCategory?: IOrganisationIndexCategory;
}) => {
  let _data = (data || []).map((item, index) => ({
    ...item,
    id: index,
  }));
  return (
    <div>
      <div
        style={{
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Typography.Title style={{ fontSize: 15, marginBottom: 10 }}>
          {selectedCategory &&
            `Za odabranu kategoriju deskriptora: ${selectedCategory.name}`}
        </Typography.Title>
      </div>
      <DataGrid
        translate={translate}
        keyProperty="id"
        dataSource={_data}
        pageSize={50}
        columns={[
          {
            key: "indexType",
            dataIndex: "indexType",
            sorter: false,
            title: translate("reports.harmonization_report.index_type"),
          },
          {
            key: "parentName",
            dataIndex: "parentName",
            sorter: false,
            title: translate("reports.harmonization_report.parent_name"),
          },
          {
            key: "harmonizedLabel",
            sorter: false,
            dataIndex: "harmonizedLabel",
            title: translate("reports.harmonization_report.harmonized_label"),
          },
          ...(organisations || []).map((org, index) => ({
            key: `org-column-${index}`,
            title: org.name,
            sorter: false,
            render: (value, record: TIndexHarmonizationReportItem) => {
              return record.organisationIndexNames[index];
            },
          })),
        ]}
      ></DataGrid>
    </div>
  );
};

export default IndexHarmonizationReportPreview;
